
import React from "react";
import DashboardWelcome from "@/components/dashboard/DashboardWelcome";
import SupabaseDebugger from "@/components/debug/SupabaseDebugger";

const Dashboard = () => {
  // Show debugging information in development
  const showDebugger = process.env.NODE_ENV !== 'production';

  return (
    <div className="space-y-6">
      <DashboardWelcome />
      
      {/* Show debugger in development environments */}
      {showDebugger && (
        <div className="mb-6">
          <SupabaseDebugger />
        </div>
      )}
    </div>
  );
};

export default Dashboard;
